<template>
  <section class="listing">
    <div class="header">
      <div class="title">Atualizações</div>
      <!-- <button @click="print" class="button-save"><i class="fas fa-print"></i><span>Imprimir</span></button> -->
    </div>
    <!-- <form @submit.prevent class="form form-search">
      <input v-model="iniDate" @change="getData" type="date" />
      <input v-model="endDate" @change="getData" type="date" />
      <input v-model="search" type="text" placeholder="Pesquisar..." />
    </form> -->
    <form @submit.prevent="getData" class="form form-search">
      <div class="form-inputs">
        <div class="form-inputs-line">
          <input v-model="iniDate" type="date" style="flex-grow: 1" />
          <input v-model="endDate" type="date" style="flex-grow: 1" />
        </div>
        <div class="form-inputs-line">
          <select v-model="type">
            <option :value="null">Tipo</option>
            <option value="profit">Nelógica</option>
            <option value="ninja">Ninja</option>
          </select>
        </div>
      </div>
      <div>
        <button type="submit" class="btn-search">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </form>
    <div class="print-header">
      <div class="print-title">Atualizações</div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div class="sum-group">
          <div class="sum">
            <span>Assinantes</span>
            <span>{{ transactions.length }}</span>
          </div>
        </div>
        <div v-for="(t, i) in filtered" :key="i" class="list">
          <div class="data">
            <div class="main-data">{{ t.name }}</div>
            <div class="detail-data">{{ type === 'ninja' ? 'NinjaTrader' : t.platform }}</div>
          </div>
          <div style="text-align: right">
            <!--<div class="main-data">{{ t.refundAmount ? (t.amount - t.refundAmount).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : t.amount.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>-->
            <div class="detail-data">{{ t.dates }}</div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/indicators'

export default {
  data () {
    return {
      loading: true,
      transactions: [],
      iniDate: null,
      endDate: null,
      refund: null,
      search: '',
      type: 'profit',
      detail: null,
      transactionsOK: []
    }
  },
  computed: {
    filtered () {
      return this.transactions.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {

  },
  async mounted () {
    try {
      const dateIni = new Date()
      const dateFim = new Date()
      dateFim.setMonth(dateFim.getMonth() + 1)
      dateFim.setDate(1)
      dateFim.setDate(dateFim.getDate() - 1)
      this.endDate = dateFim.toISOString().split('T')[0]

      dateIni.setDate(1)
      // date.setDate(date.getDate() - 90)
      this.iniDate = dateIni.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const transactions = await getAll(this.iniDate, this.endDate, this.type)
        this.transactions = transactions || []
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.form-search {
  flex-direction: row;
  align-items: center;
  padding: 0;
  padding-bottom: 10px;

  .form-inputs {
    width: calc(100% - 45px);
  }

  .form-inputs-line {
    display: flex;
    flex-wrap: wrap;
  }

  input, select {
    flex-grow: 1;
    margin: 5px;
  }
}

.btn-search {
  flex-shrink: 0;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  width: 39px;
  height: 39px;
  color: #fff;
  border-radius: 50%;
  border: 1px solid $primary-color;
  cursor: pointer;
  font-size: 1.1em;
  margin-left: 5px;
  &:focus {
    outline: 0;
  }
}
.list {
  border: 1px solid #918f8f;
}
.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  margin-right: 10px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.form-search {
  display: flex;
  flex-direction: row;
  padding: 0;
  padding-bottom: 10px;

  input {
    flex: 1;
    margin: 0 5px;
  }
}

.button-action:hover {
  i {
    animation-name: ticket-image !important;
    animation-duration: 0.5s !important;
    animation-iteration-count: 1 !important;
  }
}

.sum-group {
  display: flex;
  flex-wrap: wrap;
  .sum {
    display: flex;
    flex-basis: calc(100% - 10px);
    margin: 0 5px 10px;
    span {
      text-align: center;
      padding: 8px 0;
      flex-basis: 50%;
    }
    span:nth-child(1) {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
      border-radius: 5px 0 0 5px;
      border: 1px solid $secondary-color;
    }
    span:nth-child(2) {
      font-weight: bold;
      color: $secondary-color;
      border-radius: 0 5px 5px 0;
      border: 1px solid $secondary-color;
    }
  }
  .sum2 {
    span:nth-child(1) {
      color: #555;
      background: #e5e5e5;
      border: 1px solid #555;
      border-right: none;
      font-weight: bold;
    }
    span:nth-child(2) {
      color: #555;
      border: 1px solid #555;
    }
  }
}

.button-save {
  color: #fff;
  border: none;
  border-radius: 100px;
  // box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
  }
}

.print-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid $primary-color;
  padding: 20px 15px;
  margin-bottom: 20px !important;
}

.print-title {
  font-size: 2em;
  color: $primary-color;
  font-weight: 500;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
}

@media print {
  .admin-router {
    margin: 0;
  }
  .print-header {
    display: block;
  }
  .header, .form-search {
    display: none !important;
  }
  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }
  .list {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
